__webpack_require__.p = "https://ikea.marat.qd.je/ch/it/customer-service/support/";